import {
  HStack,
  Icon,
  SimpleGrid,
  Skeleton,
  Spacer,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Arrow } from '@cronos-app/icons';
import { currentWallet } from '@cronos-app/wallet';
import useBaraVaultUserInfo from '@ui/hooks/contracts/BaraVault/useBaraVaultUserInfo';
import { useCurrentVault } from '@ui/hooks/stores/useCurrentVault';
import { useStakeModal } from '@ui/hooks/stores/useStakeModalView';
import type { VaultCardInfo } from '@ui/interfaces/vault.interface';
import isNil from 'lodash-es/isNil';
import { useTranslations } from 'next-intl';

import { AprSubtitle, Title } from '../Atoms/AprSubTitle';
import VaultCardConnected from '../Atoms/VaultCardConneted';
import { VaultCardNotConnected } from '../VaultCardNotConnected';

const cardBackgrounds = [
  'linear-gradient(90deg, #9028FF 0%, #7042F8 46.87%);',
  'linear-gradient(90deg, #7243FA 0%, #575AF4 46.87%);',
  'linear-gradient(90deg, #575AF4 0%, #2584EB 46.87%), linear-gradient(90deg, #7243FA 0%, #575AF4 46.87%)',
];

type VaultCardProps = VaultCardInfo;

export const VaultCard = (props: VaultCardProps) => {
  const { apr, pid, lockPeriodTitle } = props;
  const { data } = useBaraVaultUserInfo();

  const t = useTranslations();
  const { setCurrentVault } = useCurrentVault();
  const isConnected = currentWallet.useIsConnectedToSupportedChain();
  const openVaultModal = useStakeModal((s) => s.openModal);

  const handleClick = () => {
    if (isConnected && props.lockPeriodTitle && data) {
      setCurrentVault(props);
      openVaultModal(
        data.poolTotalStakeMap[pid].isZero() ? 'deposit' : 'currentVault',
      );
    }
  };

  return (
    <SimpleGrid
      w="full"
      minH={{ base: 32, lg: 36 }}
      columns={2}
      cursor={isConnected ? 'pointer' : 'default'}
      onClick={handleClick}
      rounded="2xl"
      overflow="hidden"
      boxShadow="0px 13.048px 0px 0px rgba(0, 0, 0, 0.30)"
      outline={2}
      outlineStyle="solid"
      outlineColor="rgba(255, 255, 255, 0.3)"
    >
      <VStack background={cardBackgrounds[pid]} p={4} align="start" gapY={0}>
        <Skeleton w="full" minH={6} loading={isNil(lockPeriodTitle)}>
          <Title>{lockPeriodTitle}</Title>
        </Skeleton>
        <Skeleton w="full" loading={isNil(apr)}>
          <AprSubtitle apr={apr} />
        </Skeleton>
        <Spacer />
        <HStack textStyle="body-2" gapX={1}>
          <Text color="white">{t('common.Stake Now')}</Text>
          <Icon boxSize={3} color="white">
            <Arrow />
          </Icon>
        </HStack>
      </VStack>
      <VStack background="#42246D" alignItems="flex-start" gapY={0}>
        {isConnected ? (
          <VaultCardConnected {...props} />
        ) : (
          <VaultCardNotConnected />
        )}
      </VStack>
    </SimpleGrid>
  );
};
